import React from 'react';
import { PanelLeft } from 'lucide-react';

interface InnovationWorkspaceButtonProps {
  onClick: () => void;
  className?: string;
}

const InnovationWorkspaceButton: React.FC<InnovationWorkspaceButtonProps> = ({ onClick, className = '' }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center gap-2.5 rounded-xl border border-[#43C8F5] bg-white px-4 py-2 text-sm font-bold text-[#43C8F5] hover:bg-[#43C8F5]/5 transition-colors ${className}`}
  >
    Innovation Workspace
    <PanelLeft className="w-4 h-4 shrink-0" strokeWidth={2} aria-hidden />
  </button>
);

export default InnovationWorkspaceButton;
